<template>
  <div class="p-4">
    <p class="font-italic mb-4">
      {{ text }}
    </p>
    <ul class="list-unstyled mb-4">
      <li class="d-flex justify-content-between py-3 border-bottom">
        <strong class="text-muted">Order Subtotal </strong
        ><strong>{{ total | currency("₦", 0) | placeholder("₦ 0") }}</strong>
      </li>
      <li class="d-flex justify-content-between py-3 border-bottom">
        <strong class="text-muted">Shipping and handling</strong
        ><strong>₦0.00</strong>
      </li>
      <li class="d-flex justify-content-between py-3 border-bottom">
        <strong class="text-muted">Tax</strong><strong>₦0.00</strong>
      </li>
      <li class="d-flex justify-content-between py-3 border-bottom">
        <strong class="text-muted">Total</strong>
        <h5 class="font-weight-bold">
          {{ total | currency("₦", 0) | placeholder("₦ 0") }}
        </h5>
      </li>
    </ul>
    <div class="mb-3 text-center">
      <p class="mb-0"><strong>Choose Payment Method</strong></p>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="card"
          value="card"
          v-model="paymentType"
        />
        <label class="form-check-label" for="card">
          Card
        </label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="transfer"
          value="transfer"
          v-model="paymentType"
        />
        <label class="form-check-label" for="transfer">
          Transfer
        </label>
      </div>
      <div class="form-check form-check-inline">
        <input
          class="form-check-input"
          type="radio"
          id="delivery"
          value="delivery"
          v-model="paymentType"
        />
        <label class="form-check-label" for="delivery">
          Pay on Delivery
        </label>
      </div>
    </div>
    <a href="#" class="btn btn-dark rounded-pill py-2 btn-block"
      >Procceed to checkout</a
    >
  </div>
</template>

<script>
export default {
  name: "CartSummary",
  data() {
    return {
      paymentType: "card"
    };
  },
  computed: {
    cartItemData() {
      return this.$store.state.cart.cart;
    },
    total() {
      return 0;
    }
  },
  props: {
    text: {
      type: String,
      default:
        "Shipping and additional costs are calculated based on values you have entered."
    }
  }
};
</script>
